import actionTypes from './actionTypes'

const activityBanksActions = {
	mounted() {
		return {
			type: actionTypes.ACTIVITY_BANKS_MOUNTED,
		}
	},
	unmounted() {
		return {
			type: actionTypes.ACTIVITY_BANKS_UNMOUNTED,
		}
	},
	activitySelected(lesson) {
		return {
			type: actionTypes.ACTIVITY_BANKS_ACTIVITY_SELECTED,
			lesson,
		}
	},
	activitySelectedStarted() {
		return {
			type: actionTypes.ACTIVITY_BANKS_ACTIVITY_SELECTED_STARTED,
		}
	},
	activitySelectedConfirmed(lesson) {
		return {
			type: actionTypes.ACTIVITY_BANKS_ACTIVITY_SELECTED_CONFIRMED,
			lesson,
		}
	},
	activitySelectedCancelled() {
		return {
			type: actionTypes.ACTIVITY_BANKS_ACTIVITY_SELECTED_CANCELLED,
		}
	},
	activityUpdated(data) {
		return {
			type: actionTypes.ACTIVITY_BANKS_ACTIVITY_UPDATED,
			data,
		}
	},
	customActivityUpdated(data) {
		return {
			type: actionTypes.ACTIVITY_BANKS_CUSTOM_ACTIVITY_UPDATED,
			data,
		}
	},
	activityUpdateFailed(serverError, upgradeSource) {
		return {
			type: actionTypes.ACTIVITY_BANKS_ACTIVITY_UPDATE_FAILED,
			serverError,
			upgradeSource,
		}
	},
}

export default activityBanksActions
